import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { PersonsV3 } from '@frontend/api-person';
import { getFullName } from '@frontend/name';
import { Photos } from '@frontend/photos';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { ContextPreview, ContextPreviewProps } from '../../common';
import { PersonName } from './person-name';

type HeaderProps = {
  person: Person;
  contextPreviewProps?: ContextPreviewProps;
  isMobile: boolean;
};
export const Header = ({ person, contextPreviewProps, isMobile }: HeaderProps) => {
  return (
    <div
      css={{
        display: isMobile ? 'grid' : 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        gridTemplateColumns: '1fr',
      }}
    >
      <PersonBox person={person} />
      {contextPreviewProps && <ContextPreview {...contextPreviewProps} />}
    </div>
  );
};

type PersonBoxProps = {
  person: Person;
};
const PersonBox = ({ person }: PersonBoxProps) => {
  const personEmail = PersonsV3.PersonHelpers.getEmailContactType(person);
  return (
    <div
      css={{
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
        minWidth: '35%',
      }}
    >
      <Photos.ContactProfilePhoto
        personId={person?.personId ?? ''}
        disableClick
        name={person ? getFullName(person) : undefined}
      />
      <div>
        <PersonName person={person} />
        {personEmail && (
          <Text size='medium' css={{ color: theme.colorsV2.black(75) }}>
            {personEmail}
          </Text>
        )}
      </div>
    </div>
  );
};
